import { render, staticRenderFns } from "./InviteComponent.vue?vue&type=template&id=4f9c7f12&scoped=true&"
import script from "./InviteComponent.vue?vue&type=script&lang=js&"
export * from "./InviteComponent.vue?vue&type=script&lang=js&"
import style0 from "./InviteComponent.vue?vue&type=style&index=0&id=4f9c7f12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c7f12",
  null
  
)

export default component.exports